import React, { Component } from "react";
import styled from "styled-components";
import { RotateSpinLoader } from "react-css-loaders2";

class NumberOfItems extends Component {
  render() {
    const { params, meta } = this.props;

    if (!meta) {
      return <StyledLoader color="#000" size={1.5} />;
    }
    const from = params.get("offset") + 1;
    const to = meta && params.get("offset") + meta.getIn(["count"]);
    const all = meta && meta.getIn(["all"]);
    return (
      <Wrapper>
        Pokazuję {from} do {to} z {all} wpisów
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  font-size: 13px;
`;
const StyledLoader = styled(RotateSpinLoader)`margin: 0;`;

export default NumberOfItems;



// WEBPACK FOOTER //
// ./src/components/Table/NumberOfItems.js